import React from "react"
import styled from "styled-components/macro"
import colors from "../../scripts/colors"

type ContactBarTypes = {
  icon: HTMLElement
  size?: "lg" | "sm"
  smallText?: boolean
  className?: string
}

const ContactBarWrap = styled.div`
  display: flex;
  align-items: center;
  font-family: "Noto Sans JP", sans-serif;
`

const ContactBarIconBox = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors("purple")};
  width: ${(props: any) => (props.size === "lg" ? 60 : 42)}px;
  height: ${(props: any) => (props.size === "lg" ? 60 : 42)}px;
  margin-right: ${(props: any) => (props.size === "lg" ? 5 : 3)}px;
  svg {
    color: white;
    height: ${(props: any) => (props.size === "lg" ? 30 : 24)}px;
  }
  @media screen and (min-width: 1024px) {
    width: ${(props: any) => (props.size === "lg" ? 73 : 42)}px;
    height: ${(props: any) => (props.size === "lg" ? 73 : 42)}px;
    margin-right: ${(props: any) => (props.size === "lg" ? 5 : 3)}px;
    svg {
      height: ${(props: any) => (props.size === "lg" ? 42 : 24)}px;
    }
  }
`

const ContactBarContent = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: ${(props: any) => (props.smallText ? 700 : 900)};
  text-align: right;
  color: white;
  background-color: ${colors("blue", "xdk")};
  font-size: ${(props: any) =>
    props.smallText ? 15 : props.size === "lg" ? 25 : 17}px;
  height: calc(${(props: any) => (props.size === "lg" ? 52 : 36)}px - 0.15em);
  padding: 0 ${(props: any) => (props.size === "lg" ? 17 : 10)}px 0.15em;
  line-height: ${(props: any) => (props.smallText ? "20px" : "initial")};
  @media screen and (min-width: 1024px) {
    font-size: ${(props: any) =>
      props.size === "sm" ? 17 : props.smallText ? 16 : 27}px;
    height: calc(${(props: any) => (props.size === "lg" ? 62 : 36)}px - 0.15em);
    padding: 0 ${(props: any) => (props.size === "lg" ? 17 : 10)}px 0.15em;
    line-height: ${(props: any) => (props.smallText ? "1.5em" : "initial")};
  }
`

const ContactBar: React.FC<ContactBarTypes> = ({
  icon,
  size = "lg",
  children,
  smallText = false,
  className,
}) => {
  const custClass = className ? className : ""
  return (
    <ContactBarWrap
      className={
        size === "lg"
          ? `ContactBar ContactBar--lg ${custClass}`
          : `ContactBar ContactBar--sm ${custClass}`
      }
    >
      <ContactBarIconBox size={size}>{icon}</ContactBarIconBox>
      <ContactBarContent
        className="ContactBar-content"
        size={size}
        smallText={smallText}
      >
        {children}
      </ContactBarContent>
    </ContactBarWrap>
  )
}

export default ContactBar
